import { useMemo } from 'react';

import { groupMetricsByDateRange } from '@/utils/reports/chartDataUtils';

interface UseGroupedMetricByDateRangeParams {
  data: any;
  valueKey: string;
  groupKey: string;
  isRange?: boolean;
}

export const useGroupedMetricByDateRange = ({
  data,
  valueKey,
  groupKey,
  isRange = false,
}: UseGroupedMetricByDateRangeParams) =>
  useMemo(() => {
    return data
      ? groupMetricsByDateRange(
          data,
          groupKey,
          valueKey,
          'from_date',
          'to_date',
          isRange
        )
      : [];
  }, [data, valueKey, groupKey, isRange]);
